import history from 'appHistory';

export const redirectToPage = (path: string) => () => {
  history.push(`/${path}`);
};
